import { Component, inject, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DateUtilService, GungNotificationService } from 'gung-common';
import { first } from 'rxjs';
import { GungModalService } from '../../../../services/gung-modal/gung-modal.service';
import { MfaService } from '../../../../services/mfa/mfa.service';
import { UsersService } from '../../../../services/users/users.service';
import { User } from './../../../../../lib/state/auth/types';

@Component({
  selector: 'lib-user-details-mfa',
  templateUrl: './user-details-mfa.component.html',
  styleUrl: './user-details-mfa.component.scss',
  standalone: false
})
export class UserDetailsMfaComponent {
  protected route = inject(ActivatedRoute);
  protected usersService = inject(UsersService);
  protected mfaService = inject(MfaService);
  protected gungModalService = inject(GungModalService);
  protected gungNotificationService = inject(GungNotificationService);
  protected dateUtilService = inject(DateUtilService);

  @Input()
  currentUser: User;

  getUser(): void {
    this.route.paramMap.subscribe(params => {
      this.usersService
        .getAllUsers()
        .pipe(first())
        .subscribe(users => {
          this.currentUser = users.find(x => x.username === params.get('username'));
        });
    });
  }

  deleteAllMfaDevice(username: string): void {
    this.gungModalService.openConfirmYesNoModal('DELETE_ALL_MFA', 'DELETE_ALL_MFA_CONFIRMATION_TEXT').then(
      result => {
        if (result === true) {
          this.mfaService.deleteAllSetups(username).subscribe(_ => {
            this.gungNotificationService.notify('SUCCESS', 'ALL_MFA_DELETED', 'success');
            this.getUser();
          });
        }
      },
      reject => {}
    );
  }
}